import React, { useContext, useEffect, useState} from "react";
// import styles from './GeneralAssets.module.css';
import styles from '../cookies/CookiesInternal.module.css';
import userStyles from '../../pages/users/Users.module.css';
import { BrandCountryContext } from "../../providers/BrandCountryProvider";
import { useNavigate } from "react-router-dom";
import TabNavigation from "../../tabNavigation/TabNavigation";
import { LoggedInContext } from "../../providers/LoggedInContext";

export default function SchemeRequest(){

    const { linkObject , handleGetLinkObject , backendEndpoint } = useContext(LoggedInContext);
    const { brand,setBrand,country,setCountry,language,setLanguage,disable,setDisable,handlePageChange } = useContext(BrandCountryContext);

    const [file,setFile] = useState(null);
    const [loading,setLoading] = useState(false);

    useEffect(() => {
        setDisable(false);
        handlePageChange(window.location.pathname);
        handleGetLinkObject();
    },[]);

    // const handleSubmit = (e) => {
    //     e.preventDefault();

    //     if (!file) return alert("Select a file");

    //     const formData = new FormData();
    //     formData.append("file", file);

    //     setLoading(true);
    //     const headers = new Headers();
    //     headers.append('Content-Type','application/x-www-form-urlencoded');
    //     fetch(`${backendEndpoint}/upload`,{
    //         method: 'POST',
    //         body: formData,
    //         headers: headers,
    //         credentials: 'include',
    //     })
    //     .then((res) => res.text())
    //     .then((data) => {
    //         console.log(data)
    //         setLoading(false);
    //     })
    //     .catch((err) => {
    //         setLoading(false);
    //         console.log(err);
    //     });
    // }

    const imgObject =  {
        'Premio': 'url(./imgs/home/Premio_Scheme_comp.jpg)',
        'Vulco': 'url(./imgs/home/Vulco_Scheme_comp.jpg)',
        'Super Service': 'url(./imgs/home/DSC00299.jpg)'
    }

    const formLinkObject =  {
        'Premio': 'https://form.jotform.com/Stratela/premio-scheme-request-form',
        'Vulco': 'https://form.jotform.com/Stratela/vulco-scheme-request-form',
        'Super Service': ''
    }


    const handleButtonClick = () => {
        window.open(formLinkObject[brand],'_blank');
    }

    return(
        <>
            <div className={styles.container}>
                <TabNavigation selected={brand}/>
                <div className={styles.textContainer}>
                    <h4>Scheme Request</h4>
                    <br></br>
                    <p>
                    Your dedicated Goodyear Design team are here to help.<br/>
                    Here you can request a scheme and complete a submission form to get the project started.<br/>
                    Just click on the button or link below and it will take you to our Jotform submission page.<br/><br/>
                    From there, you will be guided through a short, step-by-step form allowing you to input the required project details.<br/>
                    This can be completed on either mobile or desktop devices.<br/>
Once completed your submission will be sent straight through to the design team and one of them will then shortly be in touch. <br/><br/>
                    Please note that site photos/videos will be required as part of your submission.<br/>
                    Diagrams are provided within the form to help guide you on how to correctly frame each image/video.
                    </p>
                    <br/>
                    <a href={formLinkObject[brand]} target="_blank" >{formLinkObject[brand]}</a>
                    <br/><br/>
                    <button className={userStyles.addButton} onClick={handleButtonClick}>Open Form</button>
                </div>
            </div>
            <div className={styles.background} style={{backgroundPosition: '50% 30%', backgroundImage: imgObject[brand]}}></div>
        </>
    )
}